import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {AuditTimingModel} from '@/libs/Api';
import {AuditTimingsDataService} from '@/libs/audit-timings/audit-timings-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const auditTimingsStore = registerCrudStore<AuditTimingModel, AuditTimingModel>(BusinessModule.AuditTiming, new AuditTimingsDataService());
